import { withChartLayout } from 'components/common';
import Injections from 'components/features/chart/injections/Injections';

const InjectionsPage = withChartLayout('Injections')(Injections);
export default InjectionsPage;
